import $ from "cash-dom"
import { scrollToElement } from '../util/scrollTo';

export default class BlockArrowModule {

    static name = 'blockarrow'

    constructor(node) {

        const $node = $(node)
        const $nextBlock = $node.nextAll('.block').first()

        $('<div class="block__arrow"></div>')
            .on('click', () => {
                if(!$nextBlock.length) return;
                scrollToElement($nextBlock[0], 5000)
            })
            .appendTo($node);
	}
}